<template>
  <div class="depoWithd-list-wrap">
    <div class="depo-wrap">
      <LoadingItem v-if="depositLoading" />
      <div class="depoWithd-tit">
        <div class="dw-left">
          <div class="dw-tit">충전관리</div>
          <div class="dw-btns">
            <button @click="changeListStatus('입금', '')">전체</button>
            <button @click="changeListStatus('입금', 0)">요청</button>
            <button @click="changeListStatus('입금', 1)">대기</button>
            <button @click="changeListStatus('입금', 2)">승인</button>
            <button @click="changeListStatus('입금', 3)">미승인</button>
          </div>
        </div>
        <div class="dw-right" style="margin-right: 5px">
          총충전머니 :
          <span style="color: red">{{ $addCommas(totalDepositAmount) }}</span>
        </div>
      </div>
      <table class="table-normal">
        <tr>
          <th v-for="(item, i) in depoListdTit" :key="i">{{ item }}</th>
        </tr>
        <tr v-for="(item, i) in depoList" :key="i">
          <td class="blue-name">
            {{ item.user.username }}
          </td>
          <td>
            {{ item.user.name }}
          </td>
          <td>{{ item.bank_holder }}</td>
          <td style="color: #ff6a00">{{ $addCommas(item.user.money) }}</td>
          <td style="color: #ff6a00">{{ $addCommas(item.user.point) }}</td>
          <td>{{ $addCommas(item.amount) }}</td>
          <td>{{ $addCommas(item.before_balance) }}</td>
          <td>{{ $addCommas(item.after_balance) }}</td>
          <td>{{ $addCommas(item.deposit_amount) }}</td>
          <td>{{ $addCommas(item.withdrawal_amount) }}</td>
          <td>{{ item.deposit_count }} / {{ item.withdrawal_count }}</td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.updated_at }}</td>
          <td>
            <span v-if="item.status === 0">신청</span>
            <span v-if="item.status === 1">대기</span>
            <span v-if="item.status === 2">승인</span>
            <span v-if="item.status === 3">미승인</span>
          </td>
        </tr>
      </table>
    </div>
    <!--defo-wrap -->
    <div class="withd-wrap">
      <LoadingItem v-if="withdrawalLoading" />
      <div class="depoWithd-tit">
        <div class="dw-left">
          <div class="dw-tit">환전관리</div>
          <div class="dw-btns">
            <button @click="changeListStatus('출금', '')">전체</button>
            <button @click="changeListStatus('출금', '0')">요청</button>
            <button @click="changeListStatus('출금', '1')">대기</button>
            <button @click="changeListStatus('출금', '2')">승인</button>
            <button @click="changeListStatus('출금', '3')">미승인</button>
          </div>
        </div>
        <div class="dw-right" style="margin-right: 5px">
          총환전머니 :
          <span style="color: red">{{
            $addCommas(totalWithdrawalAmount)
          }}</span>
        </div>
      </div>
      <table class="table-normal">
        <tr>
          <th v-for="(item, i) in withdListdTit" :key="i">{{ item }}</th>
        </tr>

        <tr v-for="(item, i) in withdList" :key="i">
          <td class="blue-name">
            {{ item.user.username }}
          </td>
          <td>
            {{ item.user.name }}
          </td>
          <td>{{ $addCommas(item.amount) }}</td>
          <td>{{ $addCommas(item.before_balance) }}</td>
          <td>{{ $addCommas(item.after_balance) }}</td>
          <td>{{ $addCommas(item.deposit_amount) }}</td>
          <td>{{ $addCommas(item.withdrawal_amount) }}</td>
          <td>{{ item.deposit_count }} / {{ item.withdrawal_count }}</td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.updated_at }}</td>
          <td>
            <span v-if="item.status === 0">신청</span>
            <span v-if="item.status === 1">대기</span>
            <span v-if="item.status === 2">승인</span>
            <span v-if="item.status === 3">미승인</span>
          </td>
        </tr>
      </table>
    </div>
    <!--withd-wrap -->
  </div>
  <!-- depoWidhd-wrap -->
</template>

<script>
export default {
  data() {
    return {
      depoListdTit: [
        "아이디",
        "이름",
        "입금자",
        "보유머니",
        "보유포인트",
        "입금금액",
        "신청시잔액",
        "처리후잔액",
        "당일충전",
        "당일환전",
        "횟수",
        "신청일시",
        "처리일시",
        "처리현황",
      ],
      withdListdTit: [
        "아이디",
        "이름",
        "출금금액",
        "신청시잔액",
        "처리후잔액",
        "당일충전",
        "당일환전",
        "횟수",
        "신청일시",
        "처리일시",
        "처리현황",
      ],
      depoList: [],
      totalDepositAmount: 0,
      withdList: [],
      totalWithdrawalAmount: 0,
      depositLoading: false,
      withdrawalLoading: false,
      listSet: {
        status: "",
        partnerUuid: "",
        page: 1,
        size: 99999,
        from: this.$moment().format("YYYY-MM-DD"),
        to: this.$moment().format("YYYY-MM-DD"),
      },
    };
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.from) {
        this.listSet.from = this.$route.query.from;
      }

      if (this.$route.query.to) {
        this.listSet.to = this.$route.query.to;
      }

      if (from !== to) {
        this.getList("입금");
        this.getList("출금");
      }
    },
  },
  mounted() {
    this.getList("입금");
    this.getList("출금");
  },
  methods: {
    //충환전 리스트 불러오기
    getList(type) {
      if (type === "입금") {
        this.depositLoading = true;
      } else {
        this.withdrawalLoading = true;
      }
      this.$axios
        .get(`transaction?type=${type}&${this.$qs.stringify(this.listSet)}`)
        .then((res) => {
          if (res) {
            if (type == "입금") {
              this.depoList = res.data.data;
              this.totalDepositAmount = res.data.totalAmount;
            } else {
              this.withdList = res.data.data;
              this.totalWithdrawalAmount = res.data.totalAmount;
            }
          }
        })
        .finally(() => {
          if (type === "입금") {
            this.depositLoading = false;
          } else {
            this.withdrawalLoading = false;
          }
        });
    },
    //충환전 카테고리별 리스트
    changeListStatus(type, status) {
      this.listSet.status = status;
      this.getList(type);
    },
  },
};
</script>
